import { type FC } from 'react'

import { ProductPricingAvpExplanation } from './ProductPricingAvpExplanation'
import { ProductPricingEprescriptionExplanation } from './ProductPricingEprescriptionExplanation'

export const LifeStyleProductPanel: FC = () => {
  return (
    <>
      <ProductPricingAvpExplanation />
      <ProductPricingEprescriptionExplanation />
    </>
  )
}
